import api from "../../services/api";
import {
  CLEAR_AUTH_STATE,
  EMAIL_OTP_FAILURE,
  EMAIL_OTP_REQUEST,
  EMAIL_OTP_SUCCESS,
  EMAIL_VERIFICATION_FAILURE,
  EMAIL_VERIFICATION_REQUEST,
  EMAIL_VERIFICATION_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  SEND_RESET_PASSWORD_FAILURE,
  SEND_RESET_PASSWORD_REQUEST,
  SEND_RESET_PASSWORD_SUCCESS,
  SEND_SMS_OTP_FAILURE,
  SEND_SMS_OTP_REQUEST,
  SEND_SMS_OTP_SUCCESS,
  SIGNUP_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SMS_OTP_SIGNIN_FAILURE,
  SMS_OTP_SIGNIN_REQUEST,
  SMS_OTP_SIGNIN_SUCCESS,
} from "./ActionType";

const sendSmsOtpRequest = () => {
  return {
    type: SEND_SMS_OTP_REQUEST,
  };
};

const sendSmsOtpSuccess = (success) => {
  return {
    type: SEND_SMS_OTP_SUCCESS,
    payload: success,
  };
};

const sendSmsOtpFailure = (error) => {
  return {
    type: SEND_SMS_OTP_FAILURE,
    payload: error,
  };
};

export const sendSmsOtp = (phone) => async (dispatch) => {
  dispatch(sendSmsOtpRequest());
  try {
    const response = await api.post("/otp/phone/" + phone, {
      phone,
    });
    dispatch(sendSmsOtpSuccess(response.data));
  } catch (error) {
    dispatch(sendSmsOtpFailure(error));
  }
};

const smsOtpSigninRequest = () => {
  return {
    type: SMS_OTP_SIGNIN_REQUEST,
  };
};

const smsOtpSigninSuccess = (success) => {
  return {
    type: SMS_OTP_SIGNIN_SUCCESS,
    payload: success,
  };
};

const smsOtpSigninFailure = (error) => {
  return {
    type: SMS_OTP_SIGNIN_FAILURE,
    payload: error,
  };
};

export const smsOtpSignin = (otpLoginRequest) => async (dispatch) => {
  dispatch(smsOtpSigninRequest());
  try {
    const response = await api.post("/auth/public/otp-signin", otpLoginRequest);
    dispatch(smsOtpSigninSuccess(response.data));
  } catch (error) {
    dispatch(smsOtpSigninFailure(error));
  }
};

const emailOtpRequest = () => {
  return {
    type: EMAIL_OTP_REQUEST,
  };
};

const emailOtpSuccess = (success) => {
  return {
    type: EMAIL_OTP_SUCCESS,
    payload: success,
  };
};

const emailOtpFailure = (error) => {
  return {
    type: EMAIL_OTP_FAILURE,
    payload: error,
  };
};
export const sendEmailOtp = (email) => async (dispatch) => {
  dispatch(emailOtpRequest());
  try {
    const response = await api.post("/otp/email", {
      email,
    });
    dispatch(emailOtpSuccess(response.data));
  } catch (error) {
    dispatch(emailOtpFailure(error));
  }
};

const emailVerificationRequest = () => {
  return {
    type: EMAIL_VERIFICATION_REQUEST,
  };
};

const emailVerificationSuccess = (success) => {
  return {
    type: EMAIL_VERIFICATION_SUCCESS,
    payload: success,
  };
};

const emailVerificationFailure = (error) => {
  return {
    type: EMAIL_VERIFICATION_FAILURE,
    payload: error,
  };
};

export const verifyEmail = (requestData) => async (dispatch) => {
  dispatch(emailVerificationRequest());
  try {
    const response = await api.post("/otp/email/verify", requestData);
    dispatch(emailVerificationSuccess(response.data));
  } catch (error) {
    dispatch(emailVerificationFailure(error));
  }
};

const signupRequest = () => {
  return {
    type: SIGNUP_REQUEST,
  };
};

const signupSuccess = (success) => {
  return {
    type: SIGNUP_SUCCESS,
    payload: success,
  };
};

const signupFailure = (error) => {
  return {
    type: SIGNUP_FAILURE,
    payload: error,
  };
};

export const registerUser = (signupRequestData) => async (dispatch) => {
  dispatch(signupRequest());
  try {
    const response = await api.post("/auth/public/signup", signupRequestData);
    dispatch(signupSuccess(response.data));
  } catch (error) {
    dispatch(signupFailure(error.response.data));
  }
};

const loginRequest = () => {
  return {
    type: LOGIN_REQUEST,
  };
};

const loginSuccess = (success) => {
  return {
    type: LOGIN_SUCCESS,
    payload: success,
  };
};

const loginFailure = (error) => {
  return {
    type: LOGIN_FAILURE,
    payload: error,
  };
};

export const loginUser = (loginRequestData) => async (dispatch) => {
  dispatch(loginRequest());
  try {
    const response = await api.post("/auth/public/login", loginRequestData);
    dispatch(loginSuccess(response.data));
  } catch (error) {
    const errorData = error?.response?.data || {
      success: false,
      message: "Login failed. Please check your credentials.",
    };
    dispatch(loginFailure(errorData));
  }
};

const sendResetPasswordRequest = () => {
  return {
    type: SEND_RESET_PASSWORD_REQUEST,
  };
};

const sendResetPasswordSuccess = (success) => {
  return {
    type: SEND_RESET_PASSWORD_SUCCESS,
    payload: success,
  };
};

const sendResetPasswordFailure = (error) => {
  return {
    type: SEND_RESET_PASSWORD_FAILURE,
    payload: error,
  };
};

export const sendResetPasswordToken = (email) => async (dispatch) => {
  dispatch(sendResetPasswordRequest());
  try {
    const response = await api.post("/auth/public/forgot-password", {
      email: email,
    });
    dispatch(sendResetPasswordSuccess(response.data));
  } catch (error) {
    dispatch(sendResetPasswordFailure(error.response.data));
  }
};

const resetPasswordRequest = () => {
  return {
    type: RESET_PASSWORD_REQUEST,
  };
};

const resetPasswordSuccess = (success) => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: success,
  };
};

const resetPasswordFailure = (error) => {
  return {
    type: RESET_PASSWORD_FAILURE,
    payload: error,
  };
};

export const resetPassword = (requestData) => async (dispatch) => {
  dispatch(resetPasswordRequest());
  try {
    const response = await api.post("/auth/public/reset-password", requestData);
    dispatch(resetPasswordSuccess(response.data));
  } catch (error) {
    dispatch(resetPasswordFailure(error.response.data));
  }
};

export const clearAuthState = () => {
  return {
    type: CLEAR_AUTH_STATE,
  };
};
